import React from 'react'
import { Card, Box } from '@material-ui/core'
import Content from 'components/JarCard/Content'
import SelectableTopSection from 'components/JarCard/SelectableCard/SelectableTopSection'

export default function SelectableCard({ selected, onSelect, onDeselect, id }) {
  return (
    <Card>
      <Box position='relative'>
        <SelectableTopSection { ...{ selected, onSelect, onDeselect, id } } />
      </Box>

      <Content id={id} />
    </Card>
  )
}
